import { useSetAtom } from "jotai";
import { draftReturnAtomFamily } from "../atoms/draft-return.atom";
import { updateLineItem } from "../lib/draft.lib";
import type { DraftLineItem } from "../types";

export function useUpdateLineItem(orderId: string) {
  const setDraft = useSetAtom(draftReturnAtomFamily(orderId));

  return (lineItemId: string, patch: Partial<DraftLineItem>) => {
    setDraft((draft) =>
      draft ? updateLineItem(draft, lineItemId, patch) : draft,
    );
  };
}
